// [PHASE-5 2026-10] One-time notice on the login screen after a forced
// sign-out: the 24-hour session ended, the session was revoked, or the school's
// subscription locked the account. App.js writes it to sessionStorage before
// redirecting to /login; this reads it once and forgets it.
//
// Mounted by Login.jsx (WP-B adds <LoginNotice /> above the form).
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Info, X } from 'lucide-react';
import { takeLoginNotice, loginNoticeKey, localizedServerMessage } from '../lib/sessionEvents';
import { safeStorage } from '../lib/safeStorage';

const LoginNotice = () => {
  const { t, i18n } = useTranslation();
  const [notice, setNotice] = useState(() => takeLoginNotice(safeStorage()));

  if (!notice) return null;

  const text = localizedServerMessage(notice, i18n.language) || t(loginNoticeKey(notice.reason));
  const isLock = notice.reason === 'subscription';

  return (
    <div
      role="status"
      dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
      className={`flex items-start gap-3 rounded-xl border px-4 py-3 mb-4 text-sm ${
        isLock
          ? 'bg-amber-50 border-amber-200 text-amber-900 dark:bg-amber-900/30 dark:border-amber-800 dark:text-amber-100'
          : 'bg-sky-50 border-sky-200 text-sky-900 dark:bg-sky-900/30 dark:border-sky-800 dark:text-sky-100'
      }`}
    >
      <Info className="w-4 h-4 mt-0.5 shrink-0" aria-hidden="true" />
      <p className="flex-1 leading-relaxed">{text}</p>
      <button
        type="button"
        onClick={() => setNotice(null)}
        aria-label={t('session_notice_dismiss')}
        className="shrink-0 opacity-70 hover:opacity-100"
      >
        <X className="w-4 h-4" aria-hidden="true" />
      </button>
    </div>
  );
};

export default LoginNotice;
